import { createActionConst } from '../../../../utils/action.utils';

const MEETING_SIMPLE_NAMESPACE = 'MEETINGS_SIMPLE';

export const FETCH_MEETINGS_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'FETCH_MEETINGS_SIMPLE');
export const CREATE_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CREATE_MEETING_SIMPLE');
export const UPDATE_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'UPDATE_MEETING_SIMPLE');
export const DELETE_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'DELETE_MEETING_SIMPLE');
export const UPDATE_MEETING_PARTICIPANTS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'UPDATE_MEETING_PARTICIPANTS');

export const START_MEETING_SIMPLE_SESSION = createActionConst(MEETING_SIMPLE_NAMESPACE, 'START_MEETING_SIMPLE_SESSION');
export const FINISH_MEETING_SIMPLE_SESSION = createActionConst(
  MEETING_SIMPLE_NAMESPACE,
  'FINISH_MEETING_SIMPLE_SESSION',
);

export const STORE_IS_FETCHED = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_IS_FETCHED');

export const STORE_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_MEETING_SIMPLE');
export const CLEAR_MEETING_SIMPLE = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_MEETING_SIMPLE');

export const STORE_ACCOUNTS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_ACCOUNTS');
export const CLEAR_ACCOUNTS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_ACCOUNTS');

export const STORE_TEAMS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_TEAMS');
export const CLEAR_TEAMS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_TEAMS');

export const STORE_NEXT_MEETING = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_NEXT_MEETING');
export const CLEAR_NEXT_MEETING = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_NEXT_MEETING');

export const STORE_STARTED_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_STARTED_MEETINGS');
export const CLEAR_STARTED_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_STARTED_MEETINGS');

export const STORE_FILTERED_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'STORE_FILTERED_MEETINGS');
export const CLEAR_FILTERED_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'CLEAR_FILTERED_MEETINGS');
export const FETCH_LIVE_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'FETCH_LIVE_MEETINGS');
export const SAVE_LIVE_MEETINGS = createActionConst(MEETING_SIMPLE_NAMESPACE, 'SAVE_LIVE_MEETINGS');

export const UPDATE_MEETING_SIMPLE_FOLDER = createActionConst(MEETING_SIMPLE_NAMESPACE, 'UPDATE_MEETING_SIMPLE_FOLDER');
export const SEND_MESSAGE_TO_MEETING_MEMBERS = createActionConst(
  MEETING_SIMPLE_NAMESPACE,
  'SEND_MESSAGE_TO_MEETING_MEMBERS',
);

export const JOIN_MEETING = createActionConst(MEETING_SIMPLE_NAMESPACE, 'JOIN_MEETING');
export const JOIN_MEETING_SOCKET = 'joinMeeting';

export const SAVE_MEETING_SIMPLE_SOCKET = 'saveMeeting';
export const DELETE_MEETING_SIMPLE_SOCKET = 'deleteMeeting';

export const START_MEETING_SESSION_SOCKET = 'startMeetingSession';

export const FINISH_MEETING_SIMPLE_SESSION_SOCKET = 'finishMeetingSession';

export const UPDATE_MEETING_SIMPLE_COMPLETE = createActionConst(
  MEETING_SIMPLE_NAMESPACE,
  'UPDATE_MEETING_SIMPLE_COMPLETE',
);
export const CLEAR_UPDATE_MEETING_SIMPLE_COMPLETE = createActionConst(
  MEETING_SIMPLE_NAMESPACE,
  'CLEAR_UPDATE_MEETING_SIMPLE_COMPLETE',
);
